import React, { useState } from 'react';
import SystemStatusCard from './SystemStatusCard';
import ScheduledAlertsList from './ScheduledAlertsList';
import ExecutionHistoryTable from './ExecutionHistoryTable';
import ExecutionDetailView from './ExecutionDetailView';
import AlertsPerformanceChart from './AlertsPerformanceChart';

export default function MonitoringDashboard() {
  const [selectedExecution, setSelectedExecution] = useState(null);
  const [selectedAlertId, setSelectedAlertId] = useState(null);
  const [view, setView] = useState('dashboard'); // 'dashboard' or 'detail'

  const handleExecutionSelect = (execution, alertId) => {
    setSelectedExecution(execution);
    setSelectedAlertId(alertId);
    setView('detail');
  };

  const handleCloseDetail = () => {
    setView('dashboard');
    setSelectedExecution(null);
    setSelectedAlertId(null);
  };

  return (
    <div className="container mx-auto px-4 py-6">
      {view === 'dashboard' ? (
        <>
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-800 mb-6">Alert Monitoring Dashboard</h1>
            <p className="text-gray-600 mb-4">
              Monitor your alert system performance, view upcoming executions, and analyze execution history.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
            <div className="lg:col-span-2">
              <SystemStatusCard />
            </div>
            <div>
              <ScheduledAlertsList />
            </div>
          </div>
          
          <div className="mb-8">
            <AlertsPerformanceChart />
          </div>

          <div className="bg-white shadow rounded">
            <div className="bg-purple-l border-b border-gray-200 px-6 py-2">
              <h2 className="text-white font-bold tracking-wider uppercase text-md">Execution History</h2>
            </div>
            <div className="p-4">
              <ExecutionHistoryTable onExecutionSelect={handleExecutionSelect} />
            </div>
          </div>
        </>
      ) : (
        <ExecutionDetailView 
          executionId={selectedExecution} 
          alertId={selectedAlertId} 
          onClose={handleCloseDetail} 
        />
      )}
    </div>
  );
} 